export const palette = {
  black: '#000000',

  gold300: '#C89C69',
  gold600: '#F4BE7E',

  grey100: '#F1F5FE',
  grey200: '#D3D9E1',
  grey400: '#959BA4',
  grey500: '#929292',
  grey700: '#67707D',
  grey800: '#2B2B2C',
  grey900: '#141415',
  grey900Trans: 'rgba(20, 20, 21, 0.7)',

  sky100: '#EEF1F3',
  sky400: '#8DADFF',
  sky900: '#414447',

  neutral950: '#0E0E0F',
  neutral900: '#131314',
  neutral800: '#1D1D1F',
  neutral700: '#2E2F33',
  neutral600: '#3E4147',
  neutral500: '#6E727A',
  neutral400: '#969BA3',
  neutral300: '#ADB0B8',
  neutral200: '#CED0D6',
  neutral100: '#EDF0F5',

  brand900: '#261E17',
  brand800: '#453221',
  brand700: '#815937',
  brand600: '#A1754F',
  brand500: '#F1C086',
  brand400: '#F9D09F',
  brand300: '#F7D9B4',
  brand200: '#F6E2CA',
  brand100: '#F8ECDE',

  white: '#ffffff',
};
